// sections/MobileMapsSection.tsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLocationsData, Location } from '../hooks/useLocationsData';
import { LocationsList } from '../components/MapsLocationsList';
import { MapContainer } from '../components/MapsMapContainer';

export const MobileMapsSection = () => {
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(null);
  
  const {
    categories,
    locations,
    loading,
    error,
    getLocationsByCategory,
    getVisibleLocations,
    addLocation
  } = useLocationsData();

  const handleLocationSelect = (location: Location) => {
    setSelectedLocation(location);
    // Scroll automático al mapa
    setTimeout(() => {
      const mapContainer = document.querySelector('.map-container');
      if (mapContainer) {
        mapContainer.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
    }, 100);
  };

  const visibleLocations = getVisibleLocations();

  return (
    <div className="flex flex-col h-full">
      

      {/* Lista de ubicaciones - Mitad superior */}
      <div className="flex-1 px-4 pt-6 py-2">
        <LocationsList
          categories={categories}
          locations={visibleLocations}
          onLocationSelect={handleLocationSelect}
          selectedLocationId={selectedLocation?.id}
          getLocationsByCategory={getLocationsByCategory}
          onAddLocation={addLocation}
        />
      </div>

      {/* Mapa - Mitad inferior */}
      <div className="flex-1 px-4 pb-4 map-container">
        <div className="h-full rounded-2xl overflow-hidden bg-gray-200">
          <MapContainer
            selectedLocation={selectedLocation}
            className="h-full"
          />
        </div>
      </div>
    </div>
  );
};